import { useCubeQuery } from '@cubejs-client/react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { PurchaseRequisitionSourceSystemField } from '~/common/types/cubes/PurchaseRequisitionSourceSystem';
import { BaseDetailHeader, BaseDetailHeaderProps } from '~/components/BaseDetailHeader/BaseDetailHeader';

export interface PurchaseRequisitionDetailHeaderProps {
  id: string;
  tabs?: BaseDetailHeaderProps['tabs'];
  actionsRight?: ReactNode;
}

export const PurchaseRequisitionDetailHeader = ({ id, tabs, actionsRight }: PurchaseRequisitionDetailHeaderProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'PurchaseRequisitionDetail' });

  const sourceSystemQuery = useCubeQuery({
    dimensions: [
      PurchaseRequisitionSourceSystemField.SOURCE_REFERENCE,
      PurchaseRequisitionSourceSystemField.LINK,
      PurchaseRequisitionSourceSystemField.SOURCE_SYSTEM,
    ],
    filters: [{ member: PurchaseRequisitionSourceSystemField.INTERNAL_ID, operator: 'equals', values: [id] }],
  });

  const loading = sourceSystemQuery.isLoading;

  const sourceSystemRows = sourceSystemQuery.resultSet?.rawData() ?? [];
  const externalId = (sourceSystemRows[0]?.[PurchaseRequisitionSourceSystemField.SOURCE_REFERENCE] as string) ?? '';
  const links = sourceSystemRows.map((row) => ({
    title: `${row[PurchaseRequisitionSourceSystemField.SOURCE_REFERENCE] ?? ''}`,
    url: `${row[PurchaseRequisitionSourceSystemField.LINK] ?? ''}`,
  }));

  return (
    <BaseDetailHeader
      loading={loading}
      title={t('title', { id: externalId })}
      links={links}
      tabs={tabs}
      actionsRight={actionsRight}
    />
  );
};
